import { SkitterBookPrintMargin } from '../Models/SkitterBookPrintMargin';
import { NumberStepper } from '../Controls/NumberStepper';
import './css/SkitterBookLivePrintSideMargin.css';

export interface SkitterBookPrintSideMarginProps {
    printMargin?: SkitterBookPrintMargin;
    labelText: string;
    onChange?: (value: SkitterBookPrintMargin) => void;
}

export const SkitterBookLivePrintSideMargin: React.FC<SkitterBookPrintSideMarginProps> = ({ printMargin, labelText, onChange }) => {

    return (
        <div className="skitterbook-live-print-side-margin-container">
            <div className="lpmi-page">
                <div className="lpmi-row r1">
                    <div className="lpmi-col c1">
                    </div>
                    <div className="lpmi-col c2">
                        {printMargin &&
                            <NumberStepper value={printMargin.topMm} onChange={(newValue => {
                                if (newValue) {
                                    const newPrintMargin = ({
                                        ...printMargin,
                                        topMm: newValue!
                                    });
                                    onChange?.(newPrintMargin)
                                }
                            })} />}
                    </div>
                    <div className="lpmi-col c3">
                    </div>
                </div>
                <div className="lpmi-row r2">
                    <div className="lpmi-col c1">
                        {printMargin &&
                            <NumberStepper value={printMargin.leftMm} buttonLayout="column" onChange={(newValue => {
                                if (newValue) {
                                    const newPrintMargin = ({
                                        ...printMargin,
                                        leftMm: newValue!
                                    });
                                    onChange?.(newPrintMargin)
                                }
                            })} />}
                    </div>
                    <div className="lpmi-col c2">
                        <span>{labelText}</span> 
                    </div>
                    <div className="lpmi-col c3">
                        {printMargin &&
                            <NumberStepper value={printMargin.rightMm} buttonLayout="column" onChange={(newValue => {
                                if (newValue) {
                                    const newPrintMargin = ({
                                        ...printMargin,
                                        rightMm: newValue!
                                    });
                                    onChange?.(newPrintMargin)
                                }
                            })} />}
                    </div>
                </div>
                <div className="lpmi-row r3">
                    <div className="lpmi-col c1">
                    </div>
                    <div className="lpmi-col c2">
                        {printMargin &&
                            <NumberStepper value={printMargin.bottomMm} onChange={(newValue => {
                                if (newValue) {
                                    const newPrintMargin = ({
                                        ...printMargin,
                                        bottomMm: newValue!
                                    });
                                    onChange?.(newPrintMargin)
                                }
                            })} />}
                    </div>
                    <div className="lpmi-col c3">
                    </div>
                </div>
            </div>
        </div>
    );
};
